import { TranscriptElement } from '../../types.ts/transcript';

export default class KaraokeTranscriptTrimmer {
  private elements: TranscriptElement[];

  constructor(elements: TranscriptElement[]) {
    this.elements = elements;

    this.trimElements();
  }

  public getTrimmedElements(): TranscriptElement[] {
    return this.elements;
  }

  private trimElements(): void {
    const result = [];
    for (let idx = 0; idx < this.elements.length; idx++) {
      const trimmedElement = this.trimElement(idx);
      // element can be excluded
      if (trimmedElement) {
        result.push(trimmedElement);
      }
    }
    this.elements = result;
  }

  private trimElement(idx: number): TranscriptElement | null {
    const element = this.elements[idx];
    if (['removed', 'cut'].includes(element.state ?? '')) {
      return element;
    }
    if (this.punctElementIsNewline(element)) {
      return null;
    }
    if (this.textElementContainsNewline(element)) {
      element.value = this.trimNewlines(element.value!);
    }
    return element;
  }

  private textElementContainsNewline(element: TranscriptElement): boolean {
    const text = element.value || '';
    return (
      element.type === 'text' && (text.includes('\n') || text.includes('\r'))
    );
  }

  private punctElementIsNewline(element: TranscriptElement): boolean {
    return element.type === 'punct' && element.value === '\n';
  }

  private trimNewlines(text: string): string {
    return text.replace(/[\r\n]+/g, '');
  }
}
